/**
 * A reusable error component
 */
import React from 'react';
import { Container, TextBox, Title, Text } from './Loading.styled';
import { Spinner } from '../index';
var Loading = function () {
    return (React.createElement(Container, null,
        React.createElement(Spinner, null),
        React.createElement(TextBox, null,
            React.createElement(Title, null, "Loading..."),
            React.createElement(Text, null, "Hang tight.. we're getting everything ready!"))));
};
export default Loading;
